/* eslint-disable no-underscore-dangle */
import React, {
  useState,
} from 'react';

import {
  useClickAway,
} from 'web-hooks';

import {
  Button,
  Select,
  Tooltip,
  AssignSearchOption,
} from 'web-components';

import * as S from './styled';

type Option = {
  value: string
  label: string
  newOne?: boolean
  __isNew__?: boolean
};

type Props = {
  justify?: string;
  tooltip?: string;
  buttonLabel?: any;
  isDisabled?: boolean;
  placeholder?: string;
  menuPlacement?: string;
  buttonProps?: any;
  options: Array<Option>;
  onRequestAdd?: { (option: Option): void };
  onRequestAddNew?: { (option: Option): void };
};

const CreatableEntityButton = ({
  options,
  tooltip,
  isDisabled,
  buttonLabel,
  placeholder,
  buttonProps,
  menuPlacement,
  onRequestAdd,
  onRequestAddNew,
}: Props) => {
  const [visible, setVisible] = useState(false);

  const ref = useClickAway(
    () => {
      setVisible(false);
    },
    { disabled: !visible },
  );

  if (!visible) {
    const button = (
      <Button
        {...buttonProps}
        isDisabled={isDisabled}
        onClick={() => setVisible(true)}
        noPrint
      >
        {buttonLabel}
      </Button>
    );

    return tooltip
      ? (
        <Tooltip body={tooltip} positions={['right']}>
          {button}
        </Tooltip>
      ) : button;
  }

  return (
    <S.Search ref={ref}>
      <Select
        value=""
        autoFocus
        menuIsOpen
        creatable
        placeholder={placeholder || 'Search'}
        menuPlacement={menuPlacement}
        createOptionPosition="first"
        components={{ Option: AssignSearchOption }}
        formatCreateLabel={(userInput: string) => (
          <S.Label>
            Add
            {' '}
            <b>{userInput}</b>
          </S.Label>
        )}
        options={[
          {
            newOne: true,
            value: 'new',
            label: 'CREATE NEW',
          },
          ...options,
        ]}
        styles={{
          menu: provided => ({
            ...provided,
            marginTop: '1px',
          }),
          menuList: provided => ({
            ...provided,
            maxHeight: '220px',
          }),
        }}
        onChange={(option: Option) => {
          setVisible(false);
          if (!option.value) return;
          if (option.__isNew__ || option.newOne) {
            onRequestAddNew?.(option);
          } else {
            onRequestAdd?.(option);
          }
        }}
      />
    </S.Search>
  );
};

CreatableEntityButton.defaultProps = {
  tooltip: null,
  justify: undefined,
  buttonLabel: 'Add',
  isDisabled: false,
  buttonProps: {
    appearance: 'success',
  },
  placeholder: 'Search',
  menuPlacement: 'top',
  onRequestAdd: () => {},
  onRequestAddNew: () => {},
};

export default CreatableEntityButton;
